// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"318":"517045ff","334":"bea40801","4334":"7a416966","5070":"ee9a5bec","9396":"7a416966"}[chunkId] + ".chunk.css";
};